import '../styles/home.css'

const IntroSection = ({ image, subhead, content }) => {

    const mappedContent = content.map(para => (
        <p key={para.slice(0, 10)}>{para}</p>
    ))

  return (
    <section className='home-section'>
        <aside className='img-wrapper'>
            <img src={image} alt={subhead} loading='lazy' />
        </aside>
        <article>
            <h2>{subhead}</h2>
            {mappedContent}
        </article>
    </section>
  )
}

export default IntroSection